import { Controller } from '@hotwired/stimulus'

/**
 * Показывает оригинал пользовательского текста вместо перевода.
 */
export default class TranslationController extends Controller {
  static targets = ['translated', 'original', 'link']

  /**
   * Скрывает все переведённые фрагменты в текущем блоке и раскрывает оригиналы.
   * @param {MouseEvent} event - Клик по ссылке «View original».
   * @returns {void}
   */
  showOriginal(event) {
    event.preventDefault()

    this.translatedTargets.forEach((element) => {
      element.hidden = true
    })
    this.originalTargets.forEach((element) => {
      element.hidden = false
    })
    this.linkTargets.forEach((element) => {
      element.hidden = true
    })
  }
}
